// See Youtube documentation https://developers.google.com/youtube/player_parameters.html?playerVersion=HTML5
import gtm from "../utils/GTM";

const hasStartedVideoIds = new Set();
const progressMilestones = [10, 25, 50, 75, 90];
const progressCheckIntervals = {};
const reachedMilestonesMap = {};

const VideoPlayer = (function () {
    const playBtnLocal = $(".js-play-local-video");
    const playBtnYoutube = $(".js-play-youtube-video");
    const cookieSettingsButton = $(".js-open-cookie-menu");
    const videoLocal = playBtnLocal.parent().find("video");
    let player;

    function init() {
        playBtnYoutube.on("click", function () {
            $(this).closest("#js-video-placehold-image").hide();
            $(this).closest(".embed-responsive").attr("data-clicked", true);
            if (!$("body").data("youtube-api-loaded")) {
                loadYoutube(this);
            } else {
                loadVideo();
            }
        });

        playBtnLocal.on("click", function () {
            playBtnLocal.hide();
            videoLocal.prop("controls", true);
            videoLocal.get(0).play();
        });

        videoLocal.on("ended", function () {
            videoLocal.prop("controls", true);
            playBtnLocal.show();
        });

        cookieSettingsButton.on("click", function () {
            if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
                window.OneTrust.ToggleInfoDisplay()
            }
        })
    }

    function loadVideo() {
        const videoBlocks = $(".embed-responsive[data-clicked=true]");
        for (let x = 0; x < videoBlocks.length; x++) {
            const videoId = videoBlocks[x].dataset.id;
            const videoSettings = {
                id: videoId,
                url: videoBlocks[x].dataset.url,
                start: videoBlocks[x].dataset.starttime,
                autoplay: parseYoutubeBool(true),
                playsinline: parseYoutubeBool(true),
                rel: parseYoutubeBool(false),
            };
            // eslint-disable-next-line no-undef
            player = new YT.Player("youtube_player_" + videoId, {
                playerVars: videoSettings,
                videoId,
                title: videoBlocks[x].dataset.videotitle,
                events: {
                    onStateChange: onPlayerStateChange,
                },
            });
            videoBlocks[x].dataset.clicked = false;
        }
    }

    function loadYoutube(playBtnYoutube) {
        const youtubeIframeApiUrl = "https://www.youtube.com/iframe_api";
        if (!$("script[src^='" + youtubeIframeApiUrl + "']").length > 0) {
            const videoBlock = $(playBtnYoutube).closest(".video-block__video");
            videoBlock.find(".iframe-api-script").attr({
                src: youtubeIframeApiUrl,
            });
        }
        window.onYouTubeIframeAPIReady = function () {
            loadVideo();
            $("body").attr("data-youtube-api-loaded", true);
        };
    }
    window.youtube_parser = function (url) {
        if (url === undefined) {
            return false;
        }
        const regExp =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/; // eslint-disable-line no-useless-escape
        const match = url.match(regExp);
        return match && match[7].length === 11 ? match[7] : false;
    };

    function onPlayerStateChange(event) {
        const videoId = player.playerInfo.videoData.video_id;
        switch (event.data) {
            // eslint-disable-next-line no-undef
            case YT.PlayerState.PLAYING:
                if(!hasStartedVideoIds.has(videoId)) {
                    // Only send the event once, in case user pauses and plays again
                    hasStartedVideoIds.add(videoId);
                    gtm.datalayerPush("youtube_video", {
                            video_action: 'start',
                            video_title: player.videoTitle,
                            video_duration: player.getDuration(),
                            video_id: videoId
                    });
                }
                $("body").addClass("is-playing-youtube");
                trackVideoProgress(videoId, player);
                break;
            // eslint-disable-next-line no-undef
            case YT.PlayerState.PAUSED:
                if (player.getDuration() - player.getCurrentTime() !== 0) {
                    $("body").removeClass("is-playing-youtube");
                }
                stopTrackingProgress(videoId);
                break;
            // eslint-disable-next-line no-undef
            case YT.PlayerState.ENDED:
                gtm.datalayerPush("youtube_video", {
                    video_action: 'complete',
                    video_title: player.videoTitle,
                    video_duration: player.getDuration(),
                    video_id: videoId
                });
                $("body").removeClass("is-playing-youtube");
                stopTrackingProgress(videoId);
                break;
        }
    }

    function trackVideoProgress(videoId, player) {
        if (!reachedMilestonesMap[videoId]) {
            reachedMilestonesMap[videoId] = new Set();
        }
    
        if (!progressCheckIntervals[videoId]) {
            progressCheckIntervals[videoId] = setInterval(() => {
                const duration = player.getDuration();
                const currentTime = player.getCurrentTime();
                const percentageWatched = (currentTime / duration) * 100;
    
                progressMilestones.forEach(milestone => {
                    if (percentageWatched >= milestone && !reachedMilestonesMap[videoId].has(milestone)) {
                        reachedMilestonesMap[videoId].add(milestone);
                        gtm.datalayerPush("youtube_video", {
                            video_action: 'progress',
                            video_title: player.videoTitle,
                            video_duration: duration,
                            video_id: videoId,
                            percentage_watched: milestone
                        });
                    }
                });
            }, 1000);
        }
    }
    
    function stopTrackingProgress(videoId) {
        if (progressCheckIntervals[videoId]) {
            clearInterval(progressCheckIntervals[videoId]);
            delete progressCheckIntervals[videoId];
        }
    }

    function parseYoutubeBool(jsBool) {
        return jsBool ? 1 : 0;
    }

    /* START OneTrust cookie handling, adapted from https://my.onetrust.com/s/article/UUID-7a16a9f2-4803-ccbf-75e1-8c8d3f0974aa */
    function getCookie(a) {
        var b = "; " + document.cookie;
        a = b.split("; " + a + "\x3d");
        if (2 == a.length) return a.pop().split(";").shift()
    }

    function hasRequiredConsents(required) {
        const active = (window.OnetrustActiveGroups || "")
            .split(",")
            .map(s => s.trim())
            .filter(Boolean);

        return required.every(code => active.includes(code));
    }

    function handleVideoCookies() {
        const requiredConsents = ["C0001", "C0002", "C0003", "C0004"];
        const hasConsent = hasRequiredConsents(requiredConsents);
        const $cookieMessages = $(".video-block__cookie-wrapper");
        const $playButtons = $(".js-play-youtube-video");
        if (!hasConsent) {
            if ($cookieMessages) $cookieMessages.removeClass("is-hidden");
            if ($playButtons) $($playButtons).prop('disabled', true);
        } else {
            if ($cookieMessages) $cookieMessages.addClass("is-hidden")
            if ($playButtons) $($playButtons).prop('disabled', false);
        }
        let cookieName = "OptanonAlertBoxClosed";
        // Banner 'Accept All' CTA
        const $bannerAcceptAllButton = $("#onetrust-accept-btn-handler");
        // Preference Center 'Accept All' and 'Save Settings'
        const $preferenceCenterAcceptAllButton = $("#accept-recommended-btn-handler");
        const $preferenceCenterSaveButton = $(".save-preference-btn-handler.onetrust-close-btn-handler");
        cookieName = getCookie(cookieName);
        // Page reload after consent confirmed
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !cookieName && $cookieMessages && $bannerAcceptAllButton.on("click", () => location.reload());
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        $preferenceCenterAcceptAllButton && $preferenceCenterAcceptAllButton.on("click", () => location.reload());
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        $preferenceCenterSaveButton && $preferenceCenterSaveButton.on("click", () => location.reload());
    };

    // Wait for Onetrust to load
    window.addEventListener("OneTrustGroupsUpdated", function () {
        handleVideoCookies();
    });
    /* END OneTrust cookie handling */

    return {
        init,
    };
})();

export default VideoPlayer;
